// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Qxy7u","divider":"Footer_divider__NWJMS","highlightedText":"Footer_highlightedText__miEAT"};